export default __webpack_public_path__ + "static/media/ikonka.7ac03013.svg";